import React from 'react';

// Some of our global styles are leaking into some DIG
// components. This stylesheet resets a few things.
import './reset.scss';

// Import custom DIG themes and component overrides.
import './theme/sign.scss';
import './overrides.scss';

// Import all required DIG helpers and stylesheets.
import '@dropbox/dig-components/dist/tokens.css'; // eslint-disable-line no-restricted-syntax
import '@dropbox/dig-components/dist/index.web.css'; // eslint-disable-line no-restricted-syntax
import '@dropbox/dig-fonts/dist/index.css';

// Define the HelloSign themes names.
export const signTheme = 'Sign'; // eslint-disable-line no-restricted-syntax

// Define the HelloSign DIG theme classes.
export const signThemeClassName = `dig-theme--${signTheme}`;

type DigThemeProps = {
  theme: typeof signTheme,
};

export const DigTheme: React.FunctionComponent<DigThemeProps> = ({ theme, children }) => (
  <span className={`dig-theme--${theme}`}>
    {children}
  </span>
);
